import script from "./VpBaseLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./VpBaseLayout.vue?vue&type=script&setup=true&lang=js"

import "./VpBaseLayout.vue?vue&type=style&index=0&id=23eeda4b&scoped=true&lang=css"

import exportComponent from "/home/web/idol-fandom/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23eeda4b"]])

export default __exports__